import React, { useEffect, useState, useCallback, useRef } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import axios from 'axios';
import PageLayout from "../components/pageLayout";
import { URL } from "../core/config.js"

const EmailChangeConfirmationContent = ({ token, navigateToLogin }) => {
  const [status, setStatus] = useState('loading');
  const [message, setMessage] = useState('');
  const hasRun = useRef(false);

  useEffect(() => {
    // Prevent double execution in React StrictMode
    if (hasRun.current) return;
    hasRun.current = true;

    const confirmEmail = async () => {
      try {
        await axios.get(`${URL}/users/confirm-email-change/${token}`);
        setStatus('success');
        setMessage('Your email has been successfully updated!');
        setTimeout(() => navigateToLogin(), 3000);
      } catch (error) {
        setStatus('error');
        setMessage(error.response?.data?.error || 'Invalid or expired confirmation link.');
      }
    };

    confirmEmail();
  }, [token, navigateToLogin]);

  return (
    <div style={{ textAlign: 'center', marginTop: '100px' }}>
      {status === 'loading' && <p><b>Confirming your email change...</b></p>}
      {status === 'success' && <p style={{ color: 'black' }}><b>{message}</b></p>}
      {status === 'error' && <p style={{ color: 'red' }}><b>{message}</b></p>}
    </div>
  );
};

export default function EmailChangeConfirmationPage() {
  const params = useParams();
  const history = useHistory();

  const navigateToLogin = useCallback(() => history.push('/login'), [history]);

  return (
    <PageLayout children={<EmailChangeConfirmationContent token={params.token} navigateToLogin={navigateToLogin} />}>
    </PageLayout>
  );
}